import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { LocalStorageService } from 'angular-web-storage';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom } from 'rxjs';
import { Filter, FilterOperation } from 'src/app/core/jsonapi/filter';
import { FilterBuilder } from 'src/app/core/jsonapi/filters-builder';
import { IParamsCollection } from 'src/app/core/jsonapi/interfaces/params-collection';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { CasesFilesService } from 'src/app/modules/cases/_services/cases-files.service';
import { CasesNotesFilesService } from 'src/app/modules/cases/_services/cases-notes-files.service';
import { CasesNotesService } from 'src/app/modules/cases/_services/cases-notes.service';
import { CaseFile } from 'src/app/modules/cases/_types/case-file';
import { CaseNote } from 'src/app/modules/cases/_types/case-note';
import { CaseNoteFile } from 'src/app/modules/cases/_types/case-note-file';
import { CasesNotesFileComponent } from 'src/app/modules/cases/cases-detail/file-note/file-note.component';
import { TasksService } from 'src/app/modules/tasks/_services/tasks.service';
import { File } from '../../../common/_types/file'
import { environment } from 'src/environment/environment';
import { FilesService } from 'src/app/modules/common/_services/files.service';


@Component({
    selector: 'app-notes-client',
    templateUrl: './notes-client.component.html',
    styleUrls: ['./notes-client.component.css'],
    standalone: false
})
export class NotesClientComponent implements OnInit {
public noteFormGroup!: RxFormGroup;

  public note: CaseNote = new CaseNote();
  public caseNoteFiles: any[] = [];
  public caseNoteFilesImages: any[] = [];
  public caseNoteFilesDocuments: any[] = [];

  public imagesUrl: string = environment.api_gw + 'common/files/';
  public editable: boolean = true;

  constructor(
    private caseNotesService: CasesNotesService,
    private config: DynamicDialogConfig,
    private dynamicDialogRef: DynamicDialogRef,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private formBuilder: RxFormBuilder,
    private formValidationService: FormValidatorService,
    private storage: LocalStorageService,
    private dialogService: DialogService,
    private casesNotesFilesService: CasesNotesFilesService,
    private filesService: FilesService
  ) {   
    this.editable = this.config.data?.editable;
    this.note.source = 'Client';
    this.note.caseNoteType = this.config.data.caseNoteType;
    this.note.caseId = this.config.data.caseId;
    this.note.clientId = this.config.data.clientId;
    this.note.date = new Date();
     this.noteFormGroup = this.formBuilder.formGroup<CaseNote>(this.note) as RxFormGroup;
    }
  
    async ngOnInit() {
      let noteId = this.config.data.noteId;
      if (noteId) {
        await this.loadNote(noteId);  
      }
    }

    async loadNote(noteId: string) {
      this.note = await firstValueFrom(this.caseNotesService.get(noteId));
      this.noteFormGroup.patchValue(this.note);
      this.loadNotesFiles();
    }

    cancel() {
      this.dynamicDialogRef.close();
    }

    async loadNotesFiles(){
      let params: IParamsCollection = {
        include: ['file'],
        sort: ['-createdAt']  
      }
      let filters: any = {
        caseNoteId: new Filter(FilterOperation.equals, "caseNoteId")
      };  
      filters.caseNoteId.value = this.note.id;
      params.filter = FilterBuilder.fromObject(filters).build();
  
      let response = await firstValueFrom(this.casesNotesFilesService.all(params));
      this.caseNoteFiles = response.data;
      this.caseNoteFilesImages = this.caseNoteFiles.filter(m => this.fileIsAnImage(m.file));
      this.caseNoteFilesDocuments = this.caseNoteFiles.filter(m => !this.fileIsAnImage(m.file));
    }

    async save() {
      let valid = this.formValidationService.validateForm(this.noteFormGroup);
      if (valid) {
        this.note = Object.assign(this.note, this.noteFormGroup.value);
        let note = await firstValueFrom(this.caseNotesService.save(this.note));
  
        this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Consulta guardada correctamente." });
        this.dynamicDialogRef.close(this.note.id ? null : note.id);
  
      } else {
        this.messageService.add({ closable: true, severity: 'error', summary: "Error", detail: "Existen errores, por favor revise el formulario de datos." });
      }
    }
    
    async editCaseNotesFile(caseFile: CaseNoteFile | null) {
      //guardamos la nota
      this.note = await firstValueFrom(this.caseNotesService.save(this.note));
      let ref = this.dialogService.open(CasesNotesFileComponent, {
        closable: true,
        modal: true,
        header: 'Archivo',
        width: '800px',
        data: {
          CaseNoteId: this.note.id,
          caseNoteFileId: caseFile ? caseFile.id : null
        }
      });    
      ref.onClose.subscribe((data: any) => {
        this.loadNotesFiles();
      });
    }
    fileIsAnImage(file: File) {
      return file.contentType.startsWith("image");
    }

    downloadFile(fileId: string) {
      this.filesService.download(fileId);
    }
}
